import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../spinner/spinner.service';
import { SharedHttp } from '../../services/http-client.service';
import { ComponentService } from '../../services/component.service';
import { LoginComponent } from '../login';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
let PreconfirmComponent = class PreconfirmComponent {
    constructor(route, spinner, http, router, comp, themeService, sanitizer) {
        this.route = route;
        this.spinner = spinner;
        this.http = http;
        this.router = router;
        this.comp = comp;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.loggedIn = true;
        this.stateMessage = '';
        this.textColor = '';
        this.spinner.start();
        this.loader = true;
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
        this.routeParams = this.route.params.subscribe((params) => {
            this.token = params['tkn'];
        });
        this.loader = false;
        this.spinner.stop();
        this.http.post('market/order/draft/confirm', { token: this.token }).subscribe((data) => {
            this.orderId = data['order_id'];
            this.orderType = data['order_type'];
            this.isGuest = data['guest_tx'];
            if (this.isGuest) {
                this.router.navigateByUrl('tx/confirm/' + this.orderId);
            }
            else {
                this.router.navigateByUrl('/' + this.orderType + '/confirm/' + this.orderId);
            }
        }, (error) => {
            if (error.status == 401) {
                this.spinner.stop();
                this.comp.openModal(LoginComponent);
            }
            else {
                this.loader = false;
                this.spinner.stop();
                this.stateMessage = error.error['message'];
            }
        });
    }
};
PreconfirmComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: SpinnerService },
    { type: SharedHttp },
    { type: Router },
    { type: ComponentService },
    { type: WebsiteThemeService },
    { type: DomSanitizer }
];
PreconfirmComponent = __decorate([
    Component({
        selector: 'ecd-preconfirm',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./preconfirm.component.html")).default
    })
], PreconfirmComponent);
export { PreconfirmComponent };
